import React from 'react';
import { Check, Truck } from 'lucide-react';

const inr = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

// Customer-facing package picker on /book.
export const PublicPackages = ({ packages, picked, onToggle }) => {
  if (!packages.length) return null;
  const total = packages.filter((p) => picked.includes(p.id)).reduce((s, p) => s + Number(p.price || 0), 0);
  return (
    <div data-testid="book-packages">
      <label className="mb-1 block text-sm font-semibold text-slate-800">Add a package (optional)</label>
      <p className="mb-3 text-xs text-slate-500">Prices are estimates incl. GST. Your final bill is confirmed after we inspect the car.</p>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {packages.map((p) => {
          const on = picked.includes(p.id);
          return (
            <button key={p.id} type="button" onClick={() => onToggle(p.id)} data-testid={`book-package-${p.id}`} aria-pressed={on}
              className={`relative flex flex-col justify-start overflow-hidden rounded-xl border text-left text-sm transition-[border-color,box-shadow] ${on ? 'border-teal-600 shadow-md ring-1 ring-teal-600' : 'border-slate-200 bg-white hover:border-teal-400'}`}>
              {p.popular && p.photo_url && (
                <span className="absolute right-0 top-3 z-10 rounded-l-full border border-r-0 py-1 pl-3 pr-2.5 text-[11px] font-bold uppercase tracking-wide shadow-lg" style={{ color: '#fff', backgroundColor: '#0d9488', borderColor: '#fff' }} data-testid={`book-package-popular-${p.id}`}>
                  Most popular
                </span>
              )}
              {p.photo_url && <img src={p.photo_url} alt={p.name} loading="lazy" className="aspect-[16/10] w-full object-cover" data-testid={`book-package-photo-${p.id}`} />}
              <span className={`block w-full px-4 py-3 ${on ? 'bg-teal-50' : ''}`}>
                <span className="flex items-start justify-between gap-2">
                  <span className="flex items-center gap-2 font-semibold text-slate-800">
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border ${on ? 'border-teal-600 bg-teal-600 text-white' : 'border-slate-300 bg-white'}`}>{on && <Check size={13} />}</span>
                    {p.name}
                  </span>
                  <span className="shrink-0 font-mono text-slate-700">₹ {inr(p.price)}</span>
                </span>
                {p.popular && !p.photo_url && <span className="mt-1 ml-7 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide" style={{ color: '#fff', backgroundColor: '#0d9488' }} data-testid={`book-package-popular-${p.id}`}>Most popular</span>}
                {p.description && <span className="mt-1 block pl-7 text-xs leading-snug text-slate-500">{p.description}</span>}
              </span>
            </button>
          );
        })}
      </div>
      {picked.length > 0 && (
        <p className="mt-3 flex justify-between rounded-xl bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-900" data-testid="book-packages-total">
          <span>Estimated total</span><span className="font-mono">₹ {inr(total)}</span>
        </p>
      )}
    </div>
  );
};

export const PublicPickup = ({ pickup, onChange, inputCls }) => (
  <div className="rounded-xl border border-slate-200 p-4" data-testid="book-pickup">
    <label className="flex cursor-pointer items-center justify-between gap-3">
      <span className="flex items-center gap-2 text-sm font-semibold text-slate-800"><Truck size={17} className="text-teal-700" /> Pick up my car</span>
      <input type="checkbox" className="h-5 w-5 accent-teal-600" checked={pickup.required} onChange={(e) => onChange({ required: e.target.checked })} data-testid="book-pickup-toggle" />
    </label>
    {pickup.required && (
      <div className="mt-3 grid grid-cols-1 gap-2">
        <textarea rows={2} className={inputCls} placeholder="Pickup address" value={pickup.address} onChange={(e) => onChange({ address: e.target.value })} data-testid="book-pickup-address" />
        <label className="text-xs font-semibold text-slate-600">Preferred pickup time
          <input type="time" className={`${inputCls} mt-1`} value={pickup.time} onChange={(e) => onChange({ time: e.target.value })} data-testid="book-pickup-time" />
        </label>
        <p className="text-[11px] text-slate-500">We&rsquo;ll call to confirm the driver and time.</p>
      </div>
    )}
  </div>
);
